import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import {ServiceProperties} from "../../models/service-properties";
import Helpers from "../../utils/helpers";

@Injectable()
export class ServicePropertiesControllerService {
  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getServiceProperties(serviceId: string): Observable<ServiceProperties> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/service_properties") as Observable<ServiceProperties>;
  }

  public createCServiceProperties(serviceId: string, serviceProperties: ServiceProperties) {
    Helpers.trimRecursiveObj(serviceProperties);
    const body = JSON.stringify(serviceProperties);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/service_properties", body);
  }

  public updateServiceProperties(serviceId: string, serviceProperties: ServiceProperties) {
    Helpers.trimRecursiveObj(serviceProperties);
    const body = JSON.stringify(serviceProperties);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/service_properties", body, { responseType: "text" });
  }

}
